export const operationLogsChart = {
  type: 'line',
  data: {
    labels: [],
    datasets: [
      { // another line graph
        label: 'Total de logs nos ultimos 7 dias',
        data: [],
        borderColor: 'rgba(50, 115, 220, 0.5)',
        backgroundColor: 'rgba(50, 115, 220, 0.1)',
        borderWidth: 3
      },
      { // another line graph
        label: 'Total de erros nos ultimos 7 dias',
        data: [],
        borderColor: 'rgba(255, 56, 96, 0.5)',
        backgroundColor: 'rgba(255, 56, 96, 0.1)',
        borderWidth: 3
      }
    ]
  },
  options: {
    responsive: true,
    lineTension: 1,
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          padding: 25,
        }
      }]
    }
  }
}

export default operationLogsChart;


// WEBPACK FOOTER //
// ./src/components/chart-operation-logs.js